import React from 'react';

const PageBanner = ({data}) => {
  return (
    
    <>
    <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4 pt-44 pb-48">
        <div className="relative text-white text-center flex flex-col">
          <h2 className="text-[90px] font-bold mb-10 leading-[100px]">{data.title}</h2>
          <div className="text-lg font-medium max-w-4xl w-full leading-9 mx-auto">
            <p>
              {data.description}
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default PageBanner